export const endocrine = (() => {
    const placeHolderText = 'No polyuria, polydipsia, heat or cold intolerance '

    return placeHolderText
})